export default __webpack_public_path__ + "static/media/wf-isf-engaging_employees_on_sustainability_1164x584.b0ff150c.jpg";